// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the AuthContext
const AuthContext = createContext();

// Custom hook to use the auth context
export const useAuth = () => {
  return useContext(AuthContext);
};

// AuthProvider component to wrap around the app
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userToken,setUserToken]= useState('')
    useEffect(()=>{
        const savedUser = localStorage?.getItem('authToken') || "";
        const data = savedUser && JSON.parse(savedUser)
        console.log(data)
        if(data.authToken){
            console.log("========> already login")
            setUserToken(savedUser);
            login();
        }
    },[])
  // Fake login and logout functions
  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);
  const setToken = (data) =>{
    setUserToken(data)
  }
  return (
    <AuthContext.Provider value={{ isAuthenticated, userToken, login, logout, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};